import bg from 'assets/login-bg-2.jpg'

export default function AuthLayout({children}) {
    return (
        <>

            <section className="flex flex-col items-center h-screen bg-white md:flex-row">
                <div className="hidden w-full h-screen bg-gray-400 lg:block md:w-1/3 xl:w-2/3">
                    <img src={bg} alt="login screen background" className="object-cover w-full h-full"/>
                </div>
                <div className="flex items-center justify-center w-full h-screen px-6 bg-blue-1300 md:max-w-md lg:max-w-full md:mx-auto md:w-1/2 xl:w-1/3 lg:px-16 xl:px-12">
                    <div className="w-full h-100">
                        {children}
                    </div>
                </div>
            </section>
        </>
    )
}
